export const gtagRegisterEvent = () => {
  window?.gtag?.('event', 'register', {
    entry: 'board'
  })
}

// 点击升级按钮
export const gtagUpgradeIconEvent = () => {
  window?.gtag?.('event', 'upgrade_icon_click', {
    entry: 'board'
  })
}

// 点击弹窗中的立即购买按钮
export const gtagInitiateCheckoutEvent = () => {
  window?.gtag?.('event', 'initiate_checkout', {
    entry: 'board'
  })
}

export const gtagPurchaseEvent = ({
  sku,
  currency,
  total_amount
}: {
  sku: string
  currency: string
  total_amount: number
}) => {
  console.log('gtagPurchaseEvent', sku, currency, total_amount)
  window?.gtag?.('event', 'purchase', {
    entry: 'board',
    sku,
    currency,
    total_amount
  })
}
